import type { OrusSession, SessionResult } from '@orus.eu/backend'
import { isSuccess } from '@orus.eu/result'

import type { SessionGuardOptions } from './session-access.ts'

const maxSessionAgeToDenyMs = 5_000

/** Another tab may have logged in since this copy was read, so reload it before denying unless it is fresh */
export async function readSessionForGuard(
  { context, preload }: Pick<SessionGuardOptions, 'context' | 'preload'>,
  isAllowed: (session: OrusSession) => boolean,
): Promise<SessionResult> {
  const sessionResult = await context.session.getSessionResult()
  if (preload || !isSuccess(sessionResult) || isAllowed(sessionResult.output)) return sessionResult

  return context.session.getSessionResult({ maxAgeMs: maxSessionAgeToDenyMs })
}
